// extracted by mini-css-extract-plugin
module.exports = {"title":"Panel_title__2jCxg"};